import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exchange",
  "use": "icon-exchange-usage",
  "viewBox": "0 0 18.107 16.025",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.107 16.025\" id=\"icon-exchange\"><defs><style>#icon-exchange .a{fill:none;stroke:#ffebc4;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><g transform=\"translate(-1443.232 -293.823)\"><path class=\"a\" d=\"M325.291-6119.317h17.3l-5.33-5.33\" transform=\"translate(1118 6419)\" /><path class=\"a\" d=\"M342.589-6124.646h-17.3l5.33,5.329\" transform=\"translate(1118.691 6428.635)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/exchange.svg
// module id = zi5X
// module chunks = 82